module.exports = __webpack_public_path__ + "img/background022.594c2b1f.jpg";